module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre2"
    }
  }, [_vm._v("Series preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre3"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pre4"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap_tit"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("1. In the beginning: human marriage as ‘one flesh’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap2"
    }
  }, [_vm._v("2. Playing the harlot")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Committing great harlotry")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Under every green tree")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. In every public square")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The ultimate marriage as ‘one spirit’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Concluding reflections")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen_tit"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: The harlot metaphor and feminist interpretation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture references")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of authors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("God’s Unfaithful Wife")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ident12#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ad39d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/sommaire.vue
// module id = 63
// module chunks = 0